<template>
  <!-- #region template -->
  <b-container fluid>
    <template v-if="!busy">
      <b-row>
        <!-- #region total -->
        <b-col class="mb-4" cols="12">
          <b-card class="h-100 border-0 shadow-sm py-4 px-5" no-body>
            <div class="d-flex justify-content-between">
              <div>
                <p class="m-0 text-muted">Total number of requests</p>
                <p class="m-0 font-weight-bold">{{ requestsTotal() }}</p>
              </div>
              <div>
                <p class="m-0 text-muted">Requests today</p>
                <p class="m-0 font-weight-bold">{{ requestsToday() }}</p>
              </div>
              <div>
                <p class="m-0 text-muted">Total build price</p>
                <p class="m-0 font-weight-bold">{{ requestsTotalPrice() }}</p>
              </div>
              <div>
                <p class="m-0 text-muted">Average build price</p>
                <p class="m-0 font-weight-bold">{{ requestsAveragePrice() }}</p>
              </div>
              <div>
                <p class="m-0 text-muted">Most popular day</p>
                <p class="m-0 font-weight-bold">{{ requestsDay() }}</p>
              </div>
              <!-- <div>
                <p class="m-0 text-muted">Average request per day</p>
                <p class="m-0 font-weight-bold">7</p>
              </div>
              <div>
                <p class="m-0 text-muted">All time highest request per day</p>
                <p class="m-0 font-weight-bold">5</p>
              </div> -->
            </div>
          </b-card>
        </b-col>
        <!-- #endregion -->
        <!-- #region compare -->
        <b-col cols="12">
          <div class="mb-3">
            <h4 class="font-weight-medium text-dark">Analytics</h4>
            <div class="d-flex align-items-center">
              <date-range-picker opens="right" :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }" @update="update" v-model="dateRange" :maxDate="new Date()"> </date-range-picker>
              <p class="m-0 ml-2 text-muted">compared to {{ dateToString(compareRange.startDate) }} - {{ dateToString(compareRange.endDate) }}</p>
            </div>
          </div>
        </b-col>
        <!-- #region leaderboard -->
        <!-- <b-col class="mb-4" cols="12" md="4">
          <div class="h-100 border-0 shadow-sm py-4 px-5 bg-white">
            <p class="m-0 text-muted">Requests</p>
            <div class="d-flex justify-content-between align-items-center">
              <h3 class="m-0">12</h3>
              <h3 class="m-0 text-success">+12%</h3>
            </div>
            <hr />
            <b-row>
              <b-col cols="4">
                <p class="m-0">Source 22</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0">5</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0 text-right text-success">+49.2%</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <p class="m-0">Mana 24</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0">1</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0 text-right text-danger">-49.2%</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <p class="m-0">Sprit 23</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0">12</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0 text-right text-success">+49.2%</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <p class="m-0">Leichure 32</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0">8</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0 text-right text-success">+49.2%</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <p class="m-0">Marius 32</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0">4</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0 text-right text-danger">-49.2%</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <p class="m-0">Mikkel 17</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0">2</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0 text-right text-success">+49.2%</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <p class="m-0">Therese 20</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0">12</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0 text-right text-success">+49.2%</p>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col class="mb-4" cols="12" md="4">
          <div class="h-100 border-0 shadow-sm py-4 px-5 bg-white">
            <p class="m-0 text-muted">Average build price</p>
            <div class="d-flex justify-content-between align-items-center">
              <h3 class="m-0">£26.893.32</h3>
              <h3 class="m-0 text-success">+16.6%</h3>
            </div>
            <hr />
            <b-row>
              <b-col cols="4">
                <p class="m-0">Source 22</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0">£26.893.32</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0 text-right text-success">+49.2%</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <p class="m-0">Mana 24</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0">£26.893.32</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0 text-right text-danger">-49.2%</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <p class="m-0">Sprit 23</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0">£26.893.32</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0 text-right text-success">+49.2%</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <p class="m-0">Leichure 32</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0">£26.893.32</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0 text-right text-success">+49.2%</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <p class="m-0">Marius 32</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0">£26.893.32</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0 text-right text-danger">-49.2%</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <p class="m-0">Mikkel 17</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0">£26.893.32</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0 text-right text-success">+49.2%</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <p class="m-0">Therese 20</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0">£26.893.32</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0 text-right text-success">+49.2%</p>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col class="mb-4" cols="12" md="4">
          <div class="h-100 border-0 shadow-sm py-4 px-5 bg-white">
            <p class="m-0 text-muted">Markets</p>
            <div class="d-flex justify-content-between align-items-center">
              <h3 class="m-0">Spain</h3>
              <h3 class="m-0 text-success">+122%</h3>
            </div>
            <hr />
            <b-row>
              <b-col cols="4">
                <p class="m-0">Norway</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0">12</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0 text-right text-success">+49.2%</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <p class="m-0">Denmark</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0">8</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0 text-right text-danger">-49.2%</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <p class="m-0">Spain</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0">15</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0 text-right text-success">+49.2%</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <p class="m-0">Sweden</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0">2</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0 text-right text-success">+49.2%</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <p class="m-0">Finland</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0">23</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0 text-right text-danger">-49.2%</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <p class="m-0">France</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0">2</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0 text-right text-success">+49.2%</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <p class="m-0">Italy</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0">1</p>
              </b-col>
              <b-col cols="4">
                <p class="m-0 text-right text-success">+49.2%</p>
              </b-col>
            </b-row>
          </div>
        </b-col> -->
        <!-- #endregion -->
        <!-- #region charts -->
        <b-col cols="12" md="6" class="mb-5">
          <b-card class="border-0 shadow-sm p-4">
            <cChart
              ref="product"
              title="Request by Product"
              :compare="true"
              :type="ChartType.Bar"
              :current="datasets.current.data"
              :previous="datasets.previous.data"
              :options="{
                labels: {
                  current: datasets.current.label,
                  previous: datasets.previous.label,
                },
                handlers: [
                  {
                    filter: (value) => {
                      return this.country ? value.country == this.country : true
                    },
                    map: (value) => {
                      return value.configuration.product.name
                    },
                  },
                ],
                label: (value) => {
                  return value
                },
              }">
              <div class="d-flex align-items-center" style="gap: 1rem">
                <div>
                  <p class="m-0">Country</p>
                  <b-form-select v-model="country" :options="Countries" @change="$refs['product'].renderChart()">
                    <template #first>
                      <option value="null">All countries</option>
                    </template>
                  </b-form-select>
                </div>
              </div>
            </cChart>
          </b-card>
        </b-col>
        <b-col cols="12" md="6" class="mb-5">
          <b-card class="border-0 shadow-sm p-4 h-100">
            <cChart
              ref="day"
              title="Request by Day"
              :compare="true"
              :type="ChartType.Bar"
              :current="datasets.current.data"
              :previous="datasets.previous.data"
              :options="{
                labels: {
                  current: datasets.current.label,
                  previous: datasets.previous.label,
                },
                handlers: [
                  {
                    filter: (value) => {
                      return !this.product2 || value.configuration.product.reference.id == this.product2
                    },
                    map: (value) => {
                      return value._onCreateDate.toDate().getDay()
                    },
                  },
                ],
                sort: (data) => {
                  return data.sort()
                },
                label: (value) => {
                  return {
                    0: 'Monday',
                    1: 'Tuesday',
                    2: 'Wednesday',
                    3: 'Thursday',
                    4: 'Friday',
                    5: 'Saturday',
                    6: 'Sunday',
                  }[value]
                },
              }">
              <div class="d-flex align-items-center" style="gap: 1rem">
                <div>
                  <p class="m-0">Product</p>
                  <b-form-select v-model="product2" :options="products" @change="$refs['day'].renderChart()">
                    <template #first>
                      <option value="null">All products</option>
                    </template>
                  </b-form-select>
                </div>
              </div>
            </cChart>
          </b-card>
        </b-col>
        <b-col cols="12" md="12" class="mb-5">
          <b-card class="border-0 shadow-sm p-4 h-100">
            <cChart
              ref="option"
              title="Option Distribution"
              :compare="true"
              :type="ChartType.Bar"
              :current="datasets.current.data"
              :previous="datasets.previous.data"
              :options="{
                labels: {
                  current: datasets.current.label,
                  previous: datasets.previous.label,
                },
                handlers: [
                  {
                    filter: (value) => {
                      return (!this.country1 || value.country == this.country1) && (!this.product || value.configuration.product.reference.id == this.product)
                    },
                    map: (value) => {
                      let values = []
                      value.configuration.options.forEach((option) => {
                        values.push(option)
                      })
                      return values
                    },
                  },
                  {
                    filter: (value) => {
                      return (!this.category || value.category.reference.id == this.category) && value.standard == !this.standard
                    },
                    map: (value) => {
                      return value.name
                    },
                  },
                ],
                label: (value) => {
                  return value
                },
              }">
              <div class="d-flex align-items-center" style="gap: 1rem">
                <div>
                  <p class="m-0">Show standard options</p>
                  <b-form-checkbox v-model="standard" @change="$refs['option'].renderChart()"></b-form-checkbox>
                </div>
                <div>
                  <p class="m-0">Product</p>
                  <b-form-select v-model="product" :options="products" @change="$refs['option'].renderChart()">
                    <template #first>
                      <option value="null">All products</option>
                    </template>
                  </b-form-select>
                </div>
                <div>
                  <p class="m-0">Country</p>
                  <b-form-select v-model="country1" :options="Countries" @change="$refs['option'].renderChart()">
                    <template #first>
                      <option value="null">All countries</option>
                    </template>
                  </b-form-select>
                </div>
                <div>
                  <p class="m-0">Category</p>
                  <b-form-select v-model="category" :options="categories" @change="$refs['option'].renderChart()">
                    <template #first>
                      <option value="null">All categories</option>
                    </template>
                  </b-form-select>
                </div>
              </div>
            </cChart>
          </b-card>
        </b-col>
        <b-col cols="12" md="12" class="mb-5">
          <b-card class="border-0 shadow-sm p-4 h-100">
            <cChart
              ref="country"
              title="Requests by Country"
              :compare="true"
              :type="ChartType.Bar"
              :current="datasets.current.data"
              :previous="datasets.previous.data"
              :options="{
                labels: {
                  current: datasets.current.label,
                  previous: datasets.previous.label,
                },
                handlers: [
                  {
                    filter: (value) => {
                      return !this.product1 || value.configuration.product.reference.id == this.product1
                    },
                    map: (value) => {
                      return value.country
                    },
                  },
                ],
                sort: (data) => {
                  return data.sort()
                },
                label: (value) => {
                  return CountryCodes[value] || 'Other'
                },
              }">
              <div class="d-flex align-items-center" style="gap: 1rem">
                <div>
                  <p class="m-0">Product</p>
                  <b-form-select v-model="product1" :options="products" @change="$refs['country'].renderChart()">
                    <template #first>
                      <option value="null">All products</option>
                    </template>
                  </b-form-select>
                </div>
              </div>
            </cChart>
          </b-card>
        </b-col>
        <!-- #endregion -->
        <!-- #endregion -->
      </b-row>
    </template>
    <template v-else>
      <b-row class="h-100">
        <div class="h-100 w-100 text-center d-flex flex-column justify-content-center">
          <div>
            <b-spinner></b-spinner>
            <p>Loading analytics</p>
          </div>
        </div>
      </b-row>
    </template>
  </b-container>
  <!-- #endregion -->
</template>

<script>
let firstTime = true
// #region script
// #region import
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import cChart from '@/components/chartsjs/cChart.vue'
import { CountryCodes, Countries, ChartType, dateToString, formatToCurrency, Currency, Days, isToday, getCurrencyTypeFromString } from '@/utils'
import { mapActions } from 'vuex'
// #endregion

// #region export
export default {
  name: 'dAnalytics',
  components: {
    cChart,
    DateRangePicker,
  },
  data() {
    return {
      busy: true,
      dateRange: {
        startDate: undefined,
        endDate: undefined,
      },
      compareRange: {
        startDate: undefined,
        endDate: undefined,
      },

      cache: {
        products: [],
        categories: [],
        options: [],
      },
      data: {
        requests: [],
      },
      datasets: {
        current: {
          label: '',
          data: [],
        },
        previous: {
          label: '',
          data: [],
        },
      },
      products: [],
      categories: [],
      Countries,

      country: null,
      country1: null,
      product: null,
      product1: null,
      product2: null,
      category: null,
      standard: false,

      CountryCodes,
      ChartType,
      hasMounted: false,
    }
  },
  /**
   * Sets the date to today.
   */
  created() {
    this.dateRange.endDate = new Date()
    this.dateRange.endDate.setHours(23, 59, 59, 999)
    this.dateRange.startDate = new Date(this.dateRange.endDate)
    this.dateRange.startDate.setDate(this.dateRange.startDate.getDate() - 6)
    this.dateRange.startDate.setHours(0, 0, 0, 0)
    this.compareRange.endDate = new Date(this.dateRange.startDate)
    this.compareRange.startDate = new Date(this.compareRange.endDate.getTime() - (this.dateRange.endDate.getTime() - this.dateRange.startDate.getTime()))
  },
  /**
   * Gets the necessary data.
   */
  async mounted() {
    this.cache = await this['firestore/getDoc']({
      path: '_cache/CoGEnpNIVuexy5SNhojT2',
    })

    this.data.products = this.cache.products
    this.data.products.forEach((product) => {
      this.products.push({ value: product._reference.path, text: product.name })
    })

    this.data.categories = this.cache.categories
    this.data.categories.forEach((category) => {
      this.categories.push({ value: category._reference.path, text: category.name })
    })
    this.data.options = this.cache.options

    let cache = {}
    this.data.options = this.data.options.map((option) => {
      if (!option.category) return
      if (!cache[option.category.path]) {
        cache[option.category.path] = this.data.categories.find((value) => value._reference.path == option.category.path)
      }
      option.category = cache[option.category.path]
      return option
    })

    // #region configurations
    this.data.configurations = await this['firestore/getDocs']({
      path: 'configurations',
    })

    if (firstTime) {
      cache = {}
      this.data.configurations = this.data.configurations.map((configuration) => {
        configuration.options = configuration.options.map((option) => {
          if (!option) return
          if (!cache[option.path]) {
            cache[option.path] = this.data.options.find((value) => value._reference.path == option.path)
          }
          return cache[option.path]
        })
        return configuration
      })
    }
    // #endregion

    // #region requests
    this.data.requests = await this['firestore/getDocs']({
      path: 'requests',
    })

    if (firstTime) {
      this.data.requests.map((request) => {
        if (request.configuration.path) {
          request.configuration = this.data.configurations.filter((configuration) => {
            return configuration._reference.path == request.configuration.path
          })[0]
        }
        request.configuration.product = this.data.products.filter((product) => {
          return product._reference.path == request.configuration.product.path
        })[0]
        return request
      })
    }
    // #endregion
    firstTime = false
    this.busy = false
    this.update()
  },
  methods: {
    ...mapActions(['firestore/getDoc', 'firestore/getDocs']),
    dateToString,
    /**
     * Updates the date.
     */
    update() {
      this.dateRange.endDate.setHours(23, 59, 59, 999)
      this.dateRange.startDate.setHours(0, 0, 0, 0)
      this.compareRange.endDate = new Date(this.dateRange.startDate)
      this.compareRange.endDate.setDate(this.compareRange.endDate.getDate() - 1)
      this.compareRange.endDate.setHours(23, 59, 59, 999)
      this.compareRange.startDate = new Date(this.compareRange.endDate.getTime() - (this.dateRange.endDate.getTime() - this.dateRange.startDate.getTime()))

      this.datasets.current.label = `${this.dateToString(this.dateRange.startDate)} - ${this.dateToString(this.dateRange.endDate)}`
      this.datasets.previous.label = `${this.dateToString(this.compareRange.startDate)} - ${this.dateToString(this.compareRange.endDate)}`

      this.datasets.current.data = this.data.requests.filter((request) => {
        return request._onCreateDate.toDate() >= this.dateRange.startDate && request._onCreateDate.toDate() <= this.dateRange.endDate
      })
      this.datasets.previous.data = this.data.requests.filter((request) => {
        return request._onCreateDate.toDate() >= this.compareRange.startDate && request._onCreateDate.toDate() <= this.compareRange.endDate
      })
      this.$nextTick(() => {
        this.$children.forEach((children) => {
          if (children.renderChart) {
            children.renderChart()
          }
        })
      })
    },
    /**
     * Returns the most popular day of the week, that requests are made.
     * @returns {number} The day of the week
     */
    requestsDay() {
      let day = 0
      this.data.requests.forEach((request) => {
        day += request._onCreateDate.toDate().getDay()
      })
      return Days[Math.round(day / this.data.requests.length)]
    },

    /**
     * Returns the average amount of requests per day.
     * @returns {number} The average
     */
    requestsAverageDay() {
      // let days = {}
      // this.data.requests.forEach((request) => {
      //   let day = request._onCreateDate.toDate().getDay();
      //   days[day] ? days[day]++ : days[day] = 0;
      // })
      // let
      // Object.keys(days).forEach((key) => {
      // })
    },

    /**
     * Returns the average price of a request.
     * @returns {number} The average
     */
    requestsAveragePrice() {
      let totalPrice = 0
      this.data.requests.forEach((request) => {
        let price = request.configuration.price
        totalPrice += price.replace ? parseInt(request.configuration.price.replace('.', '')) : price
      })
      return formatToCurrency((totalPrice / this.data.requests.length).toString().split('.')[0], getCurrencyTypeFromString(this.cache.settings[0].currency || 'EURO'))
    },

    /**
     * Returns the total price for all requests.
     * @returns {number} The total
     */
    requestsTotalPrice() {
      let totalPrice = 0
      this.data.requests.forEach((request) => {
        let price = request.configuration.price
        totalPrice += price.replace ? parseInt(request.configuration.price.replace('.', '')) : price
      })
      return formatToCurrency(totalPrice, getCurrencyTypeFromString(this.cache.settings[0].currency || 'EURO'))
    },

    /**
     * Returns the total amount of requests.
     * @returns {number} The total
     */
    requestsTotal() {
      return this.data.requests.length
    },

    /**
     * Returns the total amount of requests made today.
     * @returns {number} The total
     */
    requestsToday() {
      let total = 0
      this.data.requests.forEach((request) => {
        if (isToday(request._onCreateDate.toDate())) {
          total++
        }
      })
      return total
    },

    // /**
    //  * Returns the peak of requests made in one day.
    //  * @returns {number} The peak
    //  */
    // requestsPeak() {},

    // /**
    //  * Returns the peak of requests made in one day.
    //  * @returns {object} The peak
    //  */
    // requestsMarkets() {},

    // /**
    //  * Returns an object with product (key) and array of requests (value),
    //  * @returns {object} The peak
    //  */
    // sortByProducts() {},
  },
}
// #endregion
// #endregion
</script>

<style lang="scss">
// #region style
// #region import
@import '@/assets/scss/_utilities';
// #endregion

.daterangepicker .btn-success {
  background-color: $primary;
}
.daterangepicker .btn-secondary {
  background-color: $primary;
}
.daterangepicker td.active {
  background-color: $primary;
}
// #endregion
</style>
